import { Box, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import styles from "./Footer.module.css";

const Footer: React.FC = () => {
  return (
    <Box data-qatag="footerContainer" className={styles.footerContainer}>
      <Box data-qatag="footerContent" className={styles.footerContent}>
        <Box data-qatag="titleTextBox">
          <Box data-qatag="titleText">
            <Typography
              data-qatag="footer.privacytext"
              variant="body1"
              style={{ color: "#8B8B8B" }}
            >
              <FormattedMessage
                defaultMessage="By clicking on the button above and creating your Solve iQ account,{br}you confirm that you have read and agree to our {terms} and {privacy}"
                values={{
                  terms: (
                    <a
                      href="https://www.solveiq.com/terms-and-conditions/"
                      className={styles.footerLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Terms of use
                    </a>
                  ),
                  privacy: (
                    <a
                      href="https://www.solveiq.com/privacy-policy/"
                      className={styles.footerLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Privacy Policy.
                    </a>
                  ),
                  br: <br />,
                }}
              />
            </Typography>
            <br />
            <Typography
              data-qatag="footer.accesstext"
              variant="body1"
              style={{ color: "#8B8B8B" }}
            >
              <FormattedMessage defaultMessage="*The 30 days of unlimited access will be granted upon completion of registration." />
              <br className={styles.spaceAfterMobile} />
            </Typography>
            <Typography
              data-qatag="footer.feedbacktext"
              variant="body1"
              style={{ color: "#8B8B8B" }}
            >
              <FormattedMessage defaultMessage="As a Solve iQ free trial user you will be provided the opportunity to provide for feedback on this service via in-app feedback tools." />
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
